import parse from 'html-react-parser';

export const decodeHTMLEntities = (text) => {
  if (!text) {
    return text;
  }

  return text.replace(/&lt;.*?&gt;/g, (match) => match.replace(/&gt;/g, '>').replace(/&lt;/g, '<'));
};

const removeAITags = (text) => {
  if (!text) {
    return text;
  }

  return text.replace(/(<notranslate>|<\/notranslate>)/g, '');
};

const parseTextForURLs = (text) => {
  if (!text) {
    return text;
  }

  const regex =
    /(?:url:|push:)?[(http(s)?):\/\/(www\.)?a-zA-Z0-9-]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g;

  return text.replace(regex, (urlWithPrefix) => {
    const url = urlWithPrefix.replace(/(url|push):/gi, '');
    let href = url;

    if (!url.match('https?://')) {
      href = `http://${url}`;
    }

    return `<a class="sg-link" href="${href}" target="_blank">${url}</a>`;
  });
};

export const parseOperatorMessage = (text) => {
  if (!text) {
    return text;
  }

  let parsedMessage = text;

  parsedMessage = removeAITags(parsedMessage);

  parsedMessage = parseTextForURLs(parsedMessage);

  return parse(parsedMessage);
};

export const parseClientMessage = (text) => {
  if (!text) {
    return text;
  }

  let parsedMessage = parseTextForURLs(text);

  return parse(parsedMessage);
};
